import { geoViewColors } from '@/ui/style/default';
import { IGeoViewColors } from '@/ui/style/types';

export const geoCaThemeColors: IGeoViewColors = {
  ...geoViewColors,
};
